const ONBOARDING_COMPLETED_KEY = "onboardingCompleted";

export function readOnboardingCompleted(): boolean {
  try {
    return localStorage.getItem(ONBOARDING_COMPLETED_KEY) === "1";
  } catch {
    return false;
  }
}

export function setOnboardingCompleted(): void {
  try {
    localStorage.setItem(ONBOARDING_COMPLETED_KEY, "1");
  } catch {
    // Best-effort persistence; onboarding may reappear next session.
  }
}
